import {
  WORKER_CONFIG_SAVE_CHANGES_BEGIN,
  WORKER_CONFIG_SAVE_CHANGES_SUCCESS,
  WORKER_CONFIG_SAVE_CHANGES_FAILURE,
  WORKER_CONFIG_SAVE_CHANGES_DISMISS_ERROR,
} from './constants';

import axios from 'axios';
import moment from 'moment';

// Rekit uses redux-thunk for async actions by default: https://github.com/gaearon/redux-thunk
// If you prefer redux-saga, you can use rekit-plugin-redux-saga: https://github.com/supnate/rekit-plugin-redux-saga
export function saveChanges(workerConfig) {
  return (dispatch) => { // optionally you can have getState as the second argument
    dispatch({
      type: WORKER_CONFIG_SAVE_CHANGES_BEGIN,
    });

    const promise = new Promise((resolve, reject) => {
      axios.put("/api/workersurvey/",{

          workerId: workerConfig.displayedUser.id,

          workerDateAvailabilities: 
          workerConfig.workerDateAvailabilities&& Object.values(workerConfig.workerDateAvailabilities)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id})),

            workerRoleAvailabilities: 
            workerConfig.workerRoleAvailabilities && Object.values(workerConfig.workerRoleAvailabilities)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id})),

            workerProperties: 
            workerConfig.workerProperties && Object.values(workerConfig.workerProperties)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id})),

            genericWorkerCostDefinitions: 
            workerConfig.genericWorkerCostDefinitions && 
            workerConfig.genericWorkerCostDefinitions
            .map(gwc => ({...gwc, id: gwc.id || 0, workerId: workerConfig.displayedUser.id})),

            workerLocationAvailabilities: 
            workerConfig.workerLocationAvailabilities && Object.values(workerConfig.workerLocationAvailabilities)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id}))
            ,

            workerLocationFrequencies: 
            workerConfig.workerLocationFrequencies && Object.values(workerConfig.workerLocationFrequencies)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id}))
            ,

            workerRoleFrequencies: 
            workerConfig.workerRoleFrequencies && Object.values(workerConfig.workerRoleFrequencies)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id}))
            ,

             workerPairs: 
             workerConfig.workerPairs && Object.values(workerConfig.workerPairs)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id}))
            ,
            workerAvailabilityFrequency: 
            workerConfig.workerAvailabilityFrequencies&& Object.values(workerConfig.workerAvailabilityFrequencies)
            .filter(wda=>wda.workerId === workerConfig.displayedUser.id)
            .map(wda => ({...wda, id: wda.wasCreated ? 0 : wda.id}))[0]
      }).then(
        (res) => {
          console.log({res});
          dispatch({
            type: WORKER_CONFIG_SAVE_CHANGES_SUCCESS,
            data: workerConfig,
          });
          resolve(res);
        },
        // Use rejectHandler as the second argument so that render errors won't be caught.
        (err) => {
          dispatch({
            type: WORKER_CONFIG_SAVE_CHANGES_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });


    return promise;
  };
}

// Async action saves request error by default, this method is used to dismiss the error info.
// If you don't want errors to be saved in Redux store, just ignore this method.
export function dismissSaveChangesError() {
  return {
    type: WORKER_CONFIG_SAVE_CHANGES_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case WORKER_CONFIG_SAVE_CHANGES_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        saveChangesPending: true,
        saveChangesError: null,
      };

    case WORKER_CONFIG_SAVE_CHANGES_SUCCESS:
      // The request is success
      return {
        ...state,
        saveChangesPending: false,
        saveChangesError: null,
        savedChanges: action.data.numChanges
      };

    case WORKER_CONFIG_SAVE_CHANGES_FAILURE:
      // The request is failed
      return {
        ...state,
        saveChangesPending: false,
        saveChangesError: action.data.error,
      };

    case WORKER_CONFIG_SAVE_CHANGES_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        saveChangesError: null,
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/features/worker-config/redux/saveChanges.js